const TIPOACESSO = {
    MENU: 1,
    PROCESSO: 2,
    LEITURA: 3
}

export default TIPOACESSO